"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObservationFlag = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _styles = require("./styles");

var _Tooltip = require("../Tooltip");

var _noPriority = _interopRequireDefault(require("../../../assets/images/flags/noPriority.svg"));

var _highPriority = _interopRequireDefault(require("../../../assets/images/flags/highPriority.svg"));

var _mediumPriority = _interopRequireDefault(require("../../../assets/images/flags/mediumPriority.svg"));

var _lowPriority = _interopRequireDefault(require("../../../assets/images/flags/lowPriority.svg"));

var _saveIconpink = _interopRequireDefault(require("../../../assets/images/generalButton/saveIconpink.svg"));

var _Modal = require("../../organisms/Modal");

var _jsxRuntime = require("react/jsx-runtime");

var ObservationFlag = function ObservationFlag(_ref) {
  var _PriorityFlags;

  var observation = _ref.observation,
      contentObservation = _ref.contentObservation,
      dataProduct = _ref.dataProduct,
      isObservationVisible = _ref.isObservationVisible,
      toggleObservation = _ref.toggleObservation,
      hideObservation = _ref.hideObservation;
  var PriorityFlags = (_PriorityFlags = {}, (0, _defineProperty2.default)(_PriorityFlags, "none", _noPriority.default), (0, _defineProperty2.default)(_PriorityFlags, "low", _lowPriority.default), (0, _defineProperty2.default)(_PriorityFlags, "medium", _mediumPriority.default), (0, _defineProperty2.default)(_PriorityFlags, "high", _highPriority.default), _PriorityFlags); //const [isObservationVisible, setObservationVisible] = useState(false);

  var _useState = (0, _react.useState)(contentObservation || ""),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      material = _useState2[0],
      setMaterial = _useState2[1];

  var _useState3 = (0, _react.useState)(observation),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      currentObservation = _useState4[0],
      setCurrentObservation = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showModal = _useState6[0],
      setShowModal = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      modalData = _useState8[0],
      setModalData = _useState8[1];

  var textareaRef = (0, _react.useRef)(null); // const toggleObservation = () => {
  //   setObservationVisible(!isObservationVisible);
  // };

  (0, _react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (isObservationVisible && !event.target.closest(".Observation") && !event.target.closest(".Container")) {
        setObservationVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return function () {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isObservationVisible]); // useEffect(() => {
  //   document.addEventListener("click", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside);
  //   };
  // }, [isObservationVisible, handleClickOutside]);

  (0, _react.useEffect)(function () {
    setMaterial(contentObservation || "");
  }, [contentObservation]);
  (0, _react.useEffect)(function () {
    setCurrentObservation(observation);
  }, [observation]);

  var saveRequest = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var dataToSend, response, succesResponse, errorResponse;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dataToSend = {
                orderId: parseInt(dataProduct.orderId),
                articleId: dataProduct.article.id_article,
                observation: textareaRef.current.value
              };
              _context.prev = 1;
              _context.next = 4;
              return _axios.default.put(process.env.REACT_APP_UPDATE_OBSERVATION, dataToSend);

            case 4:
              response = _context.sent;
              succesResponse = {
                status: true,
                message: "Información guardada correctamente",
                detail: "",
                img: true
              };
              errorResponse = {
                status: false,
                message: "Error al guardar la información",
                detail: "",
                img: false
              };
              setShowModal(true);
              setModalData(response.data.statusCode === 200 ? succesResponse : errorResponse);
              setCurrentObservation(material !== "" ? "high" : "low");
              hideObservation();
              return _context.abrupt("return", response);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    }));

    return function saveRequest() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: PriorityFlags[currentObservation],
        alt: observation,
        style: {
          cursor: "pointer"
        },
        onClick: toggleObservation
      }), isObservationVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Observation, {
        onClick: function onClick(evt) {
          evt.stopPropagation();
        },
        className: "Observation",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ServTab, {
          onClick: function onClick(evt) {
            evt.stopPropagation();
          },
          className: "close-Container",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: "Material completo"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
              ref: textareaRef,
              name: "textarea",
              rows: "10",
              cols: "50",
              style: {
                color: "black",
                padding: "5px"
              },
              value: material,
              onChange: function onChange(e) {
                return setMaterial(e.target.value);
              },
              onClick: function onClick(e) {
                return e.stopPropagation();
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SaveButton, {
            onClick: function onClick(evt) {
              evt.stopPropagation();
              saveRequest();
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _saveIconpink.default,
              alt: "Guardar"
            })
          })]
        })
      })]
    }), showModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      show: showModal,
      title: modalData.title,
      message: modalData.message,
      onClickBtnDefault: function onClickBtnDefault(event) {
        return setShowModal(false);
      }
    })]
  });
};

exports.ObservationFlag = ObservationFlag;